// import React, { useState, useEffect } from "react";
// import "./componentstyle/navbar.css";
// import logo from "../assets/logo.png";
// import { BsInstagram, BsWhatsapp } from "react-icons/bs";
// import { Link } from "react-router-dom";

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       if (offset > 50) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <nav
//       className={`navbar navbar-expand-lg${scrolled ? " navbar-scrolled" : ""}`}
//     >
//       <div className="container-fluid">
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarTogglerDemo03"
//           aria-controls="navbarTogglerDemo03"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>
//         <div className="logo">
//           <Link className="navbar-brand" to="#">
//             <img src={logo} className="logoImg" alt="Solid Export" />
//           </Link>
//         </div>
//         <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
//           <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//             <li className="nav-item">
//               <Link className="nav-link " aria-current="page" to="/">
//                 Home
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/about">
//                 About Us
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/import">
//                 Import
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/export">
//                 Export
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/event">
//                 Event
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/gellery">
//                 Gallery
//               </Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link" to="/contact">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           <div>
//             <div className="social-icons">
//               <div className="icon--style">
//                 <BsWhatsapp id="icon" />
//                 <BsInstagram id="icon" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

import React, { useState, useEffect, useRef } from "react";
import "./componentstyle/navbar.css";
import logo from "../assets/JMC-Distributors-removebg.png";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const collapseRef = useRef(null);
  const location = useLocation(); // to detect route change

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto-collapse the navbar on route change (mobile)
  useEffect(() => {
    const collapseElement = collapseRef.current;
    if (collapseElement && collapseElement.classList.contains("show")) {
      // Bootstrap uses this to collapse the menu
      const bsCollapse = window.bootstrap.Collapse.getInstance(collapseElement);
      if (bsCollapse) {
        bsCollapse.hide(); // collapse the menu
      }
    }
  }, [location.pathname]); // triggers when route changes

  return (
    <nav
      className={`navbar navbar-expand-lg${scrolled ? " navbar-scrolled" : ""}`}
    >
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="logo">
          <Link className="navbar-brand" to="#">
            <img src={logo} className="logoImg" alt="Solid Export" />
          </Link>
        </div>
        <div
          className="collapse navbar-collapse"
          id="navbarTogglerDemo03"
          ref={collapseRef}
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {[
              { path: "/", label: "Home" },
              { path: "/about", label: "About Us" },
              // { path: "/import", label: "Import" },
              { path: "/export", label: "Export" },
              // { path: "/event", label: "Event" },
              { path: "/gellery", label: "Gallery" },
              { path: "/contact", label: "Contact Us" },
            ].map((item) => (
              <li className="nav-item" key={item.path}>
                <Link className="nav-link" to={item.path}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="social-icons">
            <div className="icon--style">
              <BsWhatsapp id="icon" />
              <BsInstagram id="icon" />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
